import { StandardEvents } from '@shopify/events';
import { QuantitySelectorUpdateEvent, ThemeEvents } from '@theme/events';

class BrightfindsBundle extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.scope = this.closest('.shopify-section') || this.parentElement;
    this.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'radio') return;
      const quantity = Number(event.target.value);
      const selector = this.form?.querySelector('quantity-selector-component');
      if (selector?.setValue) selector.setValue(quantity);
      else if (this.quantityInput) this.quantityInput.value = String(quantity);
      selector?.dispatchEvent(new QuantitySelectorUpdateEvent(quantity));
      this.update();
    }, { signal });
    this.scope.addEventListener(ThemeEvents.quantitySelectorUpdate, () => this.update(), { signal });
    this.scope.addEventListener('change', (event) => {
      if (event.target === this.quantityInput) this.update();
    }, { signal });
    this.scope.addEventListener(StandardEvents.productSelect, async (event) => {
      try {
        const { detail } = await event.promise;
        if (!detail?.html) return;
        if (detail.productId && String(detail.productId) !== this.dataset.productId) return;
        const updated = detail.html.getElementById(this.id);
        if (!updated) return;
        for (const key of ['price', 'currency', 'available', 'max', 'min', 'step']) {
          this.dataset[key] = updated.dataset[key];
        }
        queueMicrotask(() => this.update());
      } catch {}
    }, { signal });
    queueMicrotask(() => this.update());
  }
  disconnectedCallback() { this.controller?.abort(); }
  get form() { return document.getElementById(this.dataset.formId); }
  get quantityInput() { return this.form?.querySelector('input[name="quantity"]'); }
  money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: this.dataset.currency || 'CAD', currencyDisplay: 'narrowSymbol'
    }).format(cents / 100) + ' ' + (this.dataset.currency || 'CAD');
  }
  update() {
    const price = Number(this.dataset.price);
    const quantity = Number(this.quantityInput?.value || 1);
    const min = Number(this.dataset.min || 1);
    const max = Number(this.dataset.max || 999999);
    const step = Number(this.dataset.step || 1);
    for (const offer of this.querySelectorAll('.bf-bundle__offer')) {
      const radio = offer.querySelector('input');
      const count = Number(radio.value);
      const percentage = Number(radio.dataset.percent);
      const regular = count * price;
      offer.querySelector('[data-offer-total]').textContent = this.money(Math.round(regular * (100 - percentage) / 100));
      const original = offer.querySelector('[data-offer-original]');
      if (original) original.textContent = this.money(regular);
      radio.disabled = this.dataset.available !== 'true' || count < min || count > max || (count - min) % step !== 0;
      radio.checked = count === quantity;
    }
  }
}
if (!customElements.get('brightfinds-bundle')) customElements.define('brightfinds-bundle', BrightfindsBundle);
